import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceResponse } from '@sdbn/appclient';
import { HttpService } from '@sdbn/appclient';
import { DeleteTransport } from '../model/out/delete-transport';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeleteTransportService {

  constructor(private tmcHttpService: HttpService) { }

  deleteTransport(deleteTransport: DeleteTransport): Observable<ServiceResponse> {
    return this.tmcHttpService.postWithContext(environment.deleteTransportEndpoint, deleteTransport);
  }

}
